import { clsx } from "clsx";
import React, { CSSProperties, memo } from "react";
import useLoadingMessage from "./hooks/useLoadingMessage";

type Props = {
  "data-testid"?: string;
  className?: string;
  message?: string;
  delay?: number; // seconds
  style?: CSSProperties;
};

const LoadingIndicator: React.FC<Props> = ({
  "data-testid": testId,
  className,
  message,
  delay,
  style
}) => {
  const [showMessage] = useLoadingMessage(
    message ? [message] : undefined,
    delay
  );
  return (
    <div
      data-testid={testId}
      className={`${clsx("loading-indicator__container", className)}`}
      style={style}
    >
      <span className="loading-indicator__loader">Loading...</span>
      {showMessage ? (
        <span className="loading-indicator__message">{message}</span>
      ) : null}
    </div>
  );
};

export default memo(LoadingIndicator);
